// extracted by mini-css-extract-plugin
export default {"message":"gift-message-card__message__LrSp2"};